import Style from "./style"

const DefaultButton = ({ children, clickEvent, minor, small, deactive, fitWidth, expandHeight }) => {

    return (
        <Style.Btn onClick={!deactive ? clickEvent : null}
            $minor={minor} $small={small} $deactive={deactive} $fitWidth={fitWidth} $expandHeight={expandHeight}>{children}</Style.Btn>
    )
}

export default DefaultButton